import { call, put, takeEvery } from 'redux-saga/effects';
import { getOperatorUser } from '../../api/OperatorUserAPI';
import {
  retrieveOperatorUserSuccessActionCreator,
  retrieveOperatorUserFailureActionCreator,
} from '../actions/OperatorUserActions';
import { RETRIEVE_OPERATOR_USER_REQUEST } from '../actions/types/OperatorUserTypes';

function* retrievedReportsWorker() {
  try {
    const reportsResponse = yield call(getOperatorUser);
    yield put(retrieveOperatorUserSuccessActionCreator(reportsResponse.data));
  } catch (error) {
    yield put(retrieveOperatorUserFailureActionCreator(error));
  }
}

function* operatorUserWatcher() {
  yield takeEvery(RETRIEVE_OPERATOR_USER_REQUEST, retrievedReportsWorker);
}

export default operatorUserWatcher;
